import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LexTranslateService } from '@app/core/services/lex-translate.service';

@Component({
  selector: 'seb-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.css']
})
export class ModalInfoComponent implements OnInit {

  @Input() modalId: string = 'modalInfo';
  @Input() modalQuestion: string;
  @Input() modalExcerpt: string;
  @Input() confirmLabel: string = ""
  @Input() cancelLabel: string = ""
  @Input() type: string = 'question';

  @Output() cancelAction = new EventEmitter();
  @Output() confirmAction = new EventEmitter();

  icons = {
    question: '/assets/img/ico-alert.svg',
    ok: '/assets/img/checkmark-circle-ok.svg',
    alert: '/assets/img/alert-triangle.svg'
  }

  constructor(public lextranslate: LexTranslateService) { }

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()
    this.cancelLabel = this.lextranslate.i18n["f2929717-3d73-4a39-8280-d41f768d092b"]
  }

  showModal() {
    (<any>$('#' + this.modalId)).modal('show');
  }

  hideModal() {
    (<any>$('#' + this.modalId)).modal('hide');
  }

  onCancelAction() {
    this.cancelAction.emit();
    this.hideModal();
  }

  onConfirmAction() {
    this.confirmAction.emit();
    this.hideModal();
  }

}
